<script lang="ts">
    import CloseIcon from "../Icons/meta/CloseIcon.svelte";

    interface Props {
        dataTestId?: string;
        id?: string;
        bgColor?: string;
        hoverColor?: string;
        textColor?: string;
        size?: "xs" | "sm" | "md" | "lg";
        extraButtonClasses?: string;
        onclick?: (event: MouseEvent) => void;
    }

    let {
        dataTestId = undefined,
        id = undefined,
        bgColor = "bg-mlight/80",
        hoverColor = "bg-mlight-darker",
        textColor = "text-white",
        size = "lg",
        extraButtonClasses = "",
        onclick,
    }: Props = $props();

    let sizeClasses = $derived(
        size === "xs"
            ? "h-6 w-6 text-sm"
            : size === "sm"
              ? "h-8 w-8 text-base"
              : size === "md"
                ? "h-10 w-10 text-lg"
                : "h-12 w-12 text-2xl",
    );

    let iconH = $derived(size === "xs" ? "h-3" : size === "sm" ? "h-4" : size === "md" ? "h-5" : "h-6");
    let iconW = $derived(size === "xs" ? "w-3" : size === "sm" ? "w-4" : size === "md" ? "w-5" : "w-6");

    function handleClick(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
        onclick?.(event);
    }
</script>

<button
    type="button"
    {id}
    class="{sizeClasses} p-0 flex items-center justify-center shadow-light hover:shadow-light-hover backdrop-blur close-window transition-all
    aspect-square text-2xl {textColor} {bgColor} hover:{hoverColor} close-btn {extraButtonClasses} rounded-full group"
    data-testid={dataTestId}
    onclick={handleClick}
    title="Закрыть"
>
    <CloseIcon height={iconH} width={iconW} />
</button>
